// extracted by mini-css-extract-plugin
export default {"header":"header__OVZyn","container":"container__J9tNr","logo":"logo__jPF5-","nav":"nav__ikPuw","active":"active__r+Z6z"};